import { render, staticRenderFns } from "./alipay_account.vue?vue&type=template&id=0638e9d5&"
import script from "./alipay_account.vue?vue&type=script&lang=ts&"
export * from "./alipay_account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports